import './bootstrap';
import Template from './oneui/modules/template';
import { formatNumberShort, formatNumberWithCommas, formatInputNumber, validateBudget, formatDate } from './utils.js';
import { createApp } from 'vue'; // Import Vue.js
import axios from 'axios';
import '../css/app.css';
//import 'chartjs-adapter-date-fns';
import router from './router'; // Import the router
import PrimeVue from 'primevue/config'; // Import PrimeVue configuration
import 'primeicons/primeicons.css';
import i18n from './i18n'; // Import the i18n configuration
import ConfirmationService from 'primevue/confirmationservice'
import DialogService from 'primevue/dialogservice'
import ToastService from 'primevue/toastservice';
import Aura from '@primevue/themes/aura';
import Toast from './components/common/Toast.vue'; // Import your Vue component
import Pagination from './components/common/Pagination.vue'; // Import your Vue component
import SingleAvatarChip from './components/common/SingleAvatarChip.vue'; // Import your Vue component
import AvatarGroup from './components/common/AvatarGroup.vue'; // Import your Vue component
import LatestFeedbacks from './components/LatestFeedbacks.vue'; // Import your Vue component
import ResponsiveGalleria from './components/ResponsiveGalleria.vue'; // Import your Vue component
import StatusButton from './components/properties/StatusButton.vue'; // Import your Vue component
import UserRoles from './components/partner/UserRoles.vue'; // Import your Vue component
import TeamsTable from './components/partner/TeamsTable.vue'; // Import your Vue component
import PartnerDashboard from './components/partner/dashboard/index.vue';
import SummaryTable from './components/charts/SummaryTable.vue';
import usersIndex from './components/partner/users/index.vue'; // Import your Vue component
import reportRoutes from './components/DeliveryReportMap.vue';
import ChangeStatusModal from './components/partner/shipments/components/ChangeStatusModal.vue'
import PhoneCallsTrackingModal from './components/partner/shipments/components/PhoneCallsTrackingModal.vue'; // Import your Vue component
import StatusTimeline from './components/partner/shipments/components/StatusTimeline.vue'; // Import your Vue component
import ScannerPage from './components/partner/shipments/ScannerPage.vue'; // Import your Vue component
import ShipmentDetails from './components/partner/shipments/ShipmentDetails.vue';
import ChangeCustodyModal from './components/partner/shipments/components/ChangeCustodyModal.vue';
import WhatsappMessageModal from './components/partner/shipments/components/WhatsappMessageModal.vue'; // Import your Vue component
import ShipmentsTable from './components/partner/shipments/components/ShipmentsTable.vue';
import ShipmentsWorkingPage from './components/partner/shipments/WorkingPage.vue'; // Import your Vue component
import ShipmentsPickupRequestPage from './components/partner/shipments/PickupRequestPage.vue'; // Import your Vue component
import ShipmentClosedPage from './components/partner/shipments/ClosedPage.vue';
import ShipmentIndexPage from './components/partner/shipments/IndexPage.vue'; // Import your Vue component
import ShipmentAssignedPage from './components/partner/shipments/AssignedPage.vue'; // Import your Vue component
import ShipmentDeletedPage from './components/partner/shipments/DeletedPage.vue'; // Import your Vue component
import AddShipmentPage from './components/partner/shipments/AddShipmentPage.vue';
import UpdateShipmentPage from './components/partner/shipments/UpdateShipmentPage.vue'; // Import your Vue component
import MapContainer from './components/partner/shipments/components/MapContainer.vue';
import TransactionsTable from './components/partner/transactions/components/TransactionsTable.vue'; // Import your Vue component
import TransactionsIndexPage from './components/partner/transactions/IndexPage.vue';
import TransactionsDeletedPage from './components/partner/transactions/DeletedPage.vue'; // Import your Vue component
import AddTransactionPage from './components/partner/transactions/AddTransactionPage.vue';
import AccountsIndexPage from './components/partner/accounts/Index.vue'; // Import your Vue component
import AccountDetailsPage from './components/partner/accounts/DetailsPage.vue'; // Import your Vue component
import DeliveryReportsIndexPage from './components/partner/delivery_reports/indexPage.vue'
import DeliveryReportsDetailsPage from './components/partner/delivery_reports/detailsPage.vue'
import DeliveryReportsTable from './components/partner/delivery_reports/components/ReportsTable.vue'
import SellerInvoicesIndexPage from './components/partner/seller_invoices/indexPage.vue'
import SellerInvoicesDetailsPage from './components/partner/seller_invoices/detailsPage.vue'
import SellerInvoicesTable from './components/partner/seller_invoices/components/InvoicesTable.vue'

import ReturnReportsIndexPage from './components/partner/return_reports/indexPage.vue'
import ReturnReportsDetailsPage from './components/partner/return_reports/detailsPage.vue'
import ReturnReportsTable from './components/partner/return_reports/components/ReportsTable.vue'

export default class App extends Template {
  constructor() {
    super();
  }
}

const app = createApp({});
app.use(router);
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            prefix: "p",
            darkModeSelector: "light",
            cssLayer: false,
        },
    },
});
app.use(ConfirmationService);
app.use(ToastService);
app.use(DialogService);
app.use(i18n);

app.component('toast', Toast);
app.component('pagination', Pagination);
app.component('latest-feedbacks-table', LatestFeedbacks);
app.component('single-avatar-chip', SingleAvatarChip);
app.component('avatar-group', AvatarGroup);
app.component('responsive-galleria', ResponsiveGalleria);
app.component('property-status-button', StatusButton);
app.component('user-roles-table', UserRoles);
app.component('teams-table', TeamsTable);
app.component('partner-dashboard', PartnerDashboard);
app.component('summary-table', SummaryTable);
app.component('status-timeline', StatusTimeline);
app.component('users-index', usersIndex);
app.component('report-routes', reportRoutes);
app.component('scanner-page', ScannerPage);
app.component('shipment-details', ShipmentDetails);
app.component('ChangeStatusModal', ChangeStatusModal);
app.component('phone-calls-tracking-modal', PhoneCallsTrackingModal);
app.component('ChangeCustodyModal', ChangeCustodyModal);
app.component('whatsapp-message-modal', WhatsappMessageModal);
app.component('shipments-table', ShipmentsTable);
app.component('map-container', MapContainer);
app.component('shipments-index-page', ShipmentIndexPage);
app.component('shipments-assigned-page', ShipmentAssignedPage);
app.component('shipments-pickup-request-page', ShipmentsPickupRequestPage);
app.component('shipments-working-page', ShipmentsWorkingPage);
app.component('shipments-closed-page', ShipmentClosedPage);
app.component('shipments-deleted-page', ShipmentDeletedPage);
app.component('add-shipment-page', AddShipmentPage);
app.component('update-shipment-page', UpdateShipmentPage);
app.component('transaction-table', TransactionsTable);
app.component('transactions-index-page', TransactionsIndexPage);
app.component('transactions-deleted-page', TransactionsDeletedPage);
app.component('add-transaction-page', AddTransactionPage);
app.component('accounts-index-page', AccountsIndexPage);
app.component('account-details-page', AccountDetailsPage);
app.component('delivery-report-index-page', DeliveryReportsIndexPage);
app.component('delivery-report-details-page', DeliveryReportsDetailsPage);
app.component('delivery-reports-table', DeliveryReportsTable);
app.component('seller-invoice-index-page', SellerInvoicesIndexPage);
app.component('seller-invoice-details-page', SellerInvoicesDetailsPage);
app.component('seller-invoices-table', SellerInvoicesTable);

app.component('return-report-index-page', ReturnReportsIndexPage);
app.component('return-report-details-page', ReturnReportsDetailsPage);
app.component('return-reports-table', ReturnReportsTable);

window.formatNumberShort = formatNumberShort;
window.formatNumberWithCommas = formatNumberWithCommas;
window.formatInputNumber = formatInputNumber;
window.validateBudget = validateBudget;
window.formatDate = formatDate;

app.mount('#main-container');